import React from 'react';

const Resume = () => {
  return (
    <section id="resume" className="resume section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Resume</h2>
        <p>
          Software Engineer specializing in cross-platform mobile application development (Flutter/Dart), BLE hardware integration, 
          and scalable backend architectures (Django REST, Supabase, Firebase). Proven track record of architecting, publishing, 
          and maintaining production applications on Google Play alongside rigorous foundations in OOP, DSA, Java, and C/C++.
        </p>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <h3 className="resume-title">Summary</h3>
            <div className="resume-item pb-0">
              <h4>MUHAMMAD JAHANZAIB IQBAL</h4>
              <p><em>Mobile Application Engineer &amp; Software Developer with hands-on experience in architecting and shipping production Flutter apps to the Google Play Store. Proficient in Bluetooth Low Energy (BLE) IoT integrations, payment gateways (Moyasar), in-app subscriptions, and REST API backends, backed by strong fundamentals in OOP and Data Structures &amp; Algorithms.</em></p>
              <ul>
                <li>Lahore, Punjab, Pakistan</li>
                <li><a href="tel:+923021164516">+92 302 1164516</a></li>
                <li><a href="mailto:jahanzaibiqbal150@gmail.com">jahanzaibiqbal150@gmail.com</a></li>
                <li><a href="https://www.linkedin.com/in/muhammad-jahanzaib-iqbal-64a994292/" target="_blank" rel="noopener noreferrer">LinkedIn Profile</a></li>
              </ul>
            </div>

            <h3 className="resume-title">Education</h3>
            <div className="resume-item">
              <h4>BACHELOR OF SCIENCE IN SOFTWARE ENGINEERING</h4>
              <h5>February 2024 - February 2028</h5>
              <p><em>COMSATS UNIVERSITY, LAHORE</em></p>
              <p>Pursuing an in-depth degree curriculum focused on software engineering methodologies, data structures, algorithms, system architecture, and modern application development.</p>
            </div>
          </div>
          
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
            <h3 className="resume-title">Technical Expertise</h3>
            <div className="resume-item">
              <h4>CORE COMPETENCIES</h4>
              <h5>Production &amp; System Engineering</h5>
              <p><em>Full-Stack Mobile &amp; System Development</em></p>
              <ul>
                <li><strong>Mobile Development:</strong> Flutter, Dart, Riverpod / BLoC, BLE Hardware Integration, In-App Purchases (IAP)</li>
                <li><strong>Backend &amp; Cloud:</strong> Python, Django REST Framework, Supabase, PostgreSQL, Firebase</li>
                <li><strong>Languages &amp; Core:</strong> Java, C/C++, Object-Oriented Programming (OOP), Data Structures &amp; Algorithms (DSA)</li>
                <li><strong>Tools &amp; Workflows:</strong> RESTful APIs, Git, GitHub, Postman, Play Console Deployment</li>
              </ul>
            </div>
            
            <div className="resume-item">
              <h4>PROJECT PORTFOLIO</h4>
              <h5>Production &amp; Academic Projects</h5>
              <p><em>Selected Implementations</em></p>
              <ul>
                <li><strong>Wonder Women (Google Play):</strong> Smart vending machine Flutter app with BLE hardware dispensing, Moyasar payment integration, wallet system, and Django REST backend.</li>
                <li><strong>Dashcode (Google Play):</strong> AI-powered mobile coding &amp; learning platform supporting 10+ languages, built-in code execution, GitHub integration, and in-app subscriptions.</li>
                <li><strong>SafeSip:</strong> Drink safety monitoring Flutter application featuring real-time active session tracking, status alerts, and user profile management.</li>
                <li><strong>QR Code Scanner:</strong> Flutter mobile app with camera integration and real-time code processing.</li>
                <li><strong>Currency Converter:</strong> Flutter app with real-time exchange rate calculations.</li>
                <li><strong>Weather App:</strong> Flutter application with weather API integration and location services.</li>
                <li><strong>Flappy Bird Game:</strong> Developed using Java and JavaFX with interactive gameplay mechanics.</li>
                <li><strong>Library Management System:</strong> Built using C programming with file handling and data management.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
